var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3e%3cpath d='M12.28 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' fill='currentColor'/%3e%3c/svg%3e";
  export default img;